import { intelligenceRoutes } from "./intelligence-routes";

export default (router: any) => {
  intelligenceRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
